<template class="back">
    <el-container>
        <el-header class="app-header">
            <div class="app-header-top">
                <div class="top-text">
                    <div>
                        <img src="data:image/jpeg;base64,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" style="height: 50px; width: 50px;">
                    </div>
                    <div style="margin-left: 10px" @click="goHome">坊间三寻</div>
                </div>
            </div>

        </el-header>

        <el-container  class="app-container">
            <el-container>
                <el-main>
                    <div class="info">
                        <div class="info-img">
                            <img :src="goodsImg"  alt="坊间三旬">
                        </div>
                        <div class="info-info">
                            <div class="info-title">{{title}}</div>
                            <div class="info-price">
                                商品单价 <span class="info-value" style="color: red">{{price}}</span>
                            </div>

                            <div class="info-code">
                                商品编号
                                <span class="info-value">{{code}}</span>
                            </div>
                            <div class="info-stock">
                                商品库存
                                <span class="info-value">{{stock}}</span>
                            </div>
                            <div class="info-return">
                                是否退单
                                <span class="info-value">{{is_return}}</span>
                            </div>
                            <div class="info-min">
                                最小下单
                                <span class="info-value">{{min}}</span>
                            </div>
                            <div class="info-max">
                                最大下单
                                <span class="info-value">{{max}}</span>
                            </div>
                            <div class="info-tips">
                                {{tips}}
                            </div>
                            <div class="info-num">
                                <span style="color: red">*</span> &nbsp;购买数量
                                <el-input-number v-model="num" @change="handleChange" :min="1" :max="max" label="描述文字"></el-input-number>
                            </div>
                            <div class="info-btn">
                                <el-button type="primary">立即购买</el-button>
                            </div>

                        </div>
                    </div>

                </el-main>
            </el-container>
        </el-container>

        <el-container  class="app-container" style="margin-top: 50px">
            <el-container>
                <el-main>
                    <div class="detail">
                        <div class="detail-title">
                            <el-link type="primary" :underline="false" style="font-size: 18px">商品详情</el-link>
                        </div>
<!--                        <hr style="color: #409EFF">-->
                        <div class="goods-content" v-html="content">
                        </div>

                    </div>
                </el-main>
            </el-container>
        </el-container>
    </el-container>
</template>

<script>

import axios from "axios";

export default {
    data() {
        return {
            id:0,
            title: '商品名称',
            goodsImg: '商品名称',
            price: 50.00,
            code: 10000,
            stock: 10,
            is_return: '是',
            num: 1,
            max: 100,
            min: 1,
            tips: '',
            content: '阿萨德',
            host:'https://admin.fjsx.net'
        }
    },
    mounted() {
        this.id = this.$router.currentRoute.query.id;
        this.getGoods();
        // console.log(this.$router.currentRoute.query.id);
    },
    methods: {
        handleChange(value) {
            console.log(value);
        },
        getGoods(){
            axios.get(this.host + '/home/index/goods_detail?id='+this.id).then(response => {
                if (response.status !== 200){
                    this.$message({
                        message: '请求失败,请稍后再试!',
                        type: 'warning'
                    });
                }
                console.log(response.data);
                this.title = response.data.title;
                this.goodsImg = response.data.images;
                this.price = response.data.price;
                this.code = response.data.goods_no;
                this.stock = response.data.stock;
                this.is_return = response.data.short;
                this.min = response.data.min;
                this.tips = response.data.biaoqian;
                this.content = response.data.content;
            }).catch(error => {
                console.log(error)
                this.$message({
                    message: '请求失败,请稍后再试!',
                    type: 'warning'
                });
            })
        },
        goHome() {
            this.$router.push('/')
        }
    }
};
</script>

<style>
.app-container {
    margin: 0 auto;
    height: 100%;
    width: 1500px;
    border: 1px solid #eee;
    box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.1);
}
.app-header{
    width: 100%;
    margin-top: 0;
    height: 450px;
    .app-header-top{
        width: 100%;
        height: 50px;
        background: #409EFF;
        margin: 0 auto;
        .top-text{
            display: flex;
            margin: auto;
            width: 1500px;
            line-height: 50px;
            font-size: 18px;
            font-weight: 500;
            color: rgb(255, 255, 255);
        }
    }
}

.info{
    width: 100%;
    height: 500px;
    margin: 0 auto;
    display: flex;

    .info-img{
        width: 500px;
        height: 500px;
        img{
            width: 500px;
            height: 500px;
        }
    }
    .info-info{
        margin-left: 100px;
        width: 800px;
        height: 500px;
        .info-title{
            font-size: 22px;
            font-weight: 500;
            color: rgb(37, 43, 58);
            line-height: 45px
        }
        .info-price,.info-code,.info-code,.info-stock,.info-return,.info-min,.info-max{
            font-weight: 400;
            font-size: 17px;
            line-height: 40px;
            color: #96a1ba;
        }
        .info-tips{
            font-weight: bold;
            font-size: 18px;
            line-height: 60px;
            color: red;
        }
        .info-btn{
            margin-top: 20px;
        }
    }
}

.detail{
    width: 100%;
    min-height: 500px;
    .detail-title{
        margin-top: -15px;
        line-height: 50px;
        border-bottom: #eee solid 1px;
    }
    .goods-content{
        width: 100%;
        min-height: 500px;
        margin-top: 15px;
    }
}

.info-value{
    margin-left: 50px;
    color: #252b3a;
}

</style>
